angular
    .module('MW.ContactManager.ContactManagerNavigationService', [
        'MW.Framework.PageStateService',
        'MW.Configuration'
    ])
    .service('ContactManagerNavigationService', [
        '$location',
        'PageStateService',
        '$window',
        'FAIRHAIR_WEB_URL',
        'IRM_BASE_URL',
        'MR_SEARCH_URL',
        function($location, PageStateService, $window, FAIRHAIR_WEB_URL, IRM_BASE_URL, MR_SEARCH_URL) {
            'use strict';

            return {
                previousLocation : null,
                clickedBackButton: false,

                // if you are using this back button & came from within the influencer app you should go back there.
                // if you did not come from within the influencer app (paste url, bookmark, browser back button, etc.), should be sent to the landing page
                smartBackAction: function smartBackAction() {
                    var locationHistoryFromSession,
                        previousLocationFromSession;

                    this.clickedBackButton = true;
                    locationHistoryFromSession = this.getIcmLocationHistoryFromSession();
                    if(Array.isArray(locationHistoryFromSession) && locationHistoryFromSession.length && $location.url() !== '/influencers/contact/landing') {
                        previousLocationFromSession = locationHistoryFromSession.pop();
                        this.setIcmLocationHistoryInSession(locationHistoryFromSession);
                        $location.url(previousLocationFromSession);
                    } else {
                        this.goToIcmLandingPage();
                    }
                },

                goToIcmLandingPage: function goToIcmLandingPage() {
                    $location.url('/influencers/contact');
                },

                goToList : function goToList() {
                    $location.url('/influencers/contact?locker=' + PageStateService.getLockerId('contactListPage'));
                },

                goToAllContactsList : function goToAllContactsList() {
                    $location.url('/influencers/contact-list');
                },

                goToContactAddLanding : function goToContactAddLanding() {
                    $location.url('/influencers/contact/landing');
                },

                goToCreate : function goToCreate() {
                    $window.location.href = `${window.location.origin}/a/media-relations/contact/create`;
                },

                goToImport : function goToImport() {
                    $location.url('/influencers/contact/import');
                },

                goToEdit : function goToEdit(contactId) {
                    $location.url('/influencers/contact/edit/' + contactId);
                },

                goToProfileView : function goToProfileView(contactId) {
                    $window.location.href = IRM_BASE_URL + '/contact/' + contactId;
                },

                goToSourceDetailView : function goToSourceDetailView(sourceId) {
                    $location.url('/influencers/source/view/' + sourceId);
                },

                goToKeywordSearch : function goToKeywordSearch() {
                    $location.url('/influencers/contact/keywordSearch');
                },

                goToSearch: function goToSearch() {
                    window.location.href = MR_SEARCH_URL;
                },

                goToDirectorySearch : function goToDirectorySearch() {
                    $location.url('/influencers/contact/search?locker=' + PageStateService.getLockerId('influencerDatabase'));
                },

                goToOutreach : function goToOutreach(mediaListIds) {
                    if (mediaListIds) {
                        $location.url('/outreach/compose?mediaListIds=' + mediaListIds);
                    } else {
                        $location.url('/outreach/compose');
                    }
                },

                goToUpsellPage : function goToUpsellPage () {
                    $location.url('/influencers/contact/influencerdatabase');
                },

                setPreviousLocation : function setPreviousLocation(location, prefixToStrip) {
                    //Easy way to just grab the path instead of the full URL
                    var el = document.createElement('a'),
                        prefixRegEx = prefixToStrip ? new RegExp('^\/?' + prefixToStrip) : '';

                    el.href = location;
                    this.previousLocation = el.pathname.replace(prefixRegEx, '') + (el.search ? el.search : '');

                    if(!this.clickedBackButton) {
                        var locationHistory = this.getIcmLocationHistoryFromSession();
                        if(Array.isArray(locationHistory)) {
                            locationHistory.push(this.previousLocation);
                            locationHistory = locationHistory.slice(-25);
                        } else {
                            locationHistory = [this.previousLocation];
                        }

                        this.setIcmLocationHistoryInSession(locationHistory);
                    } else {
                        this.clickedBackButton = false;
                    }
                },

                getPreviousLocation : function getPreviousLocation(){
                    return this.previousLocation;
                },

                resetIcmLocationHistory: function resetIcmLocationHistory() {
                    sessionStorage.removeItem('icmLocationHistory');
                },

                setIcmLocationHistoryInSession: function setIcmLocationHistoryInSession(locationHistory) {
                    sessionStorage.setItem('icmLocationHistory', JSON.stringify(locationHistory));
                },

                getIcmLocationHistoryFromSession: function getIcmLocationHistoryFromSession() {
                    return JSON.parse(sessionStorage.getItem('icmLocationHistory'));
                },

                redirectToFairhairWeb: function redirectToFairhairWeb(path) {
                    if (path === '/settings/email') {
                        $window.location.href = `${window.location.origin}/a/approved-sender`;
                    } else {
                        $window.location.href = FAIRHAIR_WEB_URL + path;
                    }
                }
            };
        }
    ]);
